/**
 * 应用路由配置模块。
 */
import type { RouteObject } from "react-router-dom";
import Client from "@/pages/Client";
import Device from "@/pages/Device";
import Dashboard from "@/pages/remote/dashboard";
import SignalConnector from "@/pages/remote/signal-connector";

const router: RouteObject[] = [
	{
		path: "/dashboard",
		element: <Dashboard />,
	},
	{
		path: "/",
		element: <SignalConnector />,
	},
	{
		path: "/device",
		element: <Device />,
	},
	{
		path: "/client",
		element: <Client />,
	},
	{
		path: "*",
		element: <SignalConnector />,
	},
];

export default router;
